const useStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    zIndex: 1,
  },
});

export default useStyles;
